import { GridItemsAlignment, GridJustification, GridProps } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import React from 'react';

export type HorizontalGridProps = Omit<GridProps, "align" | "justifyContent" | "container" | "direction"> & {
    align?: GridJustification
    verticalAlign?: GridItemsAlignment
}

export function HorizontalGrid ({ align, verticalAlign, ...props }: HorizontalGridProps) {
    return (
        <Grid {...props} container direction="row" alignItems={verticalAlign} justifyContent={align} />
    )
}